
import React from 'react';
// export default class Login extends Component {
const HomeModule = (user) => {
  // user.userHome.user.email <- getting users
    const goAdd = () => {
      window.location = 'admin/players?r=addplayer';
    }
    return (
      <div className='row'>
        <div className='col-lg-12'>
          <button className='btn btn-sm btn-primary' onClick={goAdd}>Add Player</button><br></br><br></br>
          <h3>Player Registration and Payment</h3>
          <b>Documents Required:</b><br></br>
          •Registration form<br></br>
          •Concussion form<br></br>
          •Cardiac Arrest<br></br>
          •Birth Certificate (One Time Upload)<br></br><br></br>
          <h3>Registration de alumno y Pago</h3>
          <b>Documentos requeridos:</b><br></br>
          •Formulario de Registro<br></br>
          •Forma de conmoción cerebral<br></br>
          •Forma de Paro cardiaco<br></br>
          •Acta de nacimiento (Una sola vez)<br></br><br></br>
        </div>
      </div>
    )
  // }
}

export default HomeModule;